// extracted by mini-css-extract-plugin
module.exports = {"DeckDiv":"DeckBoardControl_DeckDiv__3cCNa"};